export default __webpack_public_path__ + "static/media/main_logo_image_white.86593e46.svg";